<div class="p-d-flex p-flex-column p-mt-3" [formGroup]="otpremnicaForm">
  <!-- Tabela stavki dokumenta -->
  <p-table
    [value]="opasneMaterijeOtpremnice.controls"
    styleClass="p-datatable-striped p-datatable-gridlines"
  >
    <!-- START HEADER -->
    <ng-template pTemplate="header">
      <!-- header columns -->
      <tr class="columns">
        <th>Naziv</th>
        <th>Opis/vrednost</th>
        <th>Komentar</th>
        <th style="width: 1vw"></th>
      </tr>
    </ng-template>

    <!-- START BODY -->

    <!-- Rows -->
    <ng-template
      pTemplate="body"
      let-materija
      let-rowIndex="rowIndex"
      let-expanded="expanded"
    >
      <ng-container formArrayName="opasneMaterijeDto">
        <tr [formGroupName]="rowIndex">
          <td>
            <div class="inputFullWidth celija">
              <kodit-text-input
                [formCtrl]="materija.get('naziv')"
              ></kodit-text-input>
            </div>
          </td>
          <td class="p-text-right">
            <div
              class="inputFullWidth celija"
            >
              <kodit-text-input
                [formCtrl]="materija.get('vrednost')"
              ></kodit-text-input>
            </div>
          </td>

          <td class="p-text-right">
            <div
              class="inputFullWidth celija"
            >
              <kodit-text-input
                [formCtrl]="materija.get('komentar')"
              ></kodit-text-input>
            </div>
          </td>
          <td style="vertical-align: middle" class="p-text-center">
            <div class="celija">
              <!-- <p-tableCheckbox [value]="stavka.value"></p-tableCheckbox> -->
              <button
                *ngIf="
                  rowIndex >= brojPocetnihStavki
                "
                pButton
                pRipple
                type="button"
                icon="far fa-trash-alt"
                class="p-button-text p-button-danger"
                pTooltip="Ukloni opasnu materiju sa otpremnice"
                (click)="deleteStavka(rowIndex)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>

  <div class="p-d-flex p-mt-3">
    <button
      pButton
      pRipple
      type="button"
      icon="fas fa-plus"
      class="p-button-outlined"
      (click)="addEmptyMaterija()"
      label="Nova opasna materija"
      pTooltip="Dodaj novu oapsnu materiju na otpremnicu"
    ></button>
  </div>
</div>
